module.exports = __webpack_public_path__ + "static/stardust-icon-color-9b9a2e0e133e9767a989c5d38b322425.png";